import React from "react";
import "../styles/account-created.css";

export const AccountCreated = () => {
  return (
    <>
      <div class="digest-account-created">
        <h1 class="s48px">
          <span>
            <span class="span">✅ You have created a </span>
            <span class="span1">SOCIAL MEDIA DIGEST</span>
            <span class="span"> account</span>
          </span>
        </h1>
        <div class="return-to-home">
          <div class="s26px">
            <h2 className="s26px">
              Welcome to SOCIAL MEDIA DIGEST!<br></br>
              <br></br> Start by linking your social media accounts to receive a
              digest.
            </h2>
          </div>
          <div class="home-button-container">
            <div className="button-primary btn white s18px">Configure</div>
            <div className="button-primary btn white s18px">Settings</div>
          </div>
        </div>
      </div>
    </>
  );
};
